import React, { memo, useState } from 'react';
import * as XLSX from 'xlsx';
import * as Papa from 'papaparse';
import { Button, Upload } from 'antd';
import _find from 'lodash/find';
import _isEmpty from 'lodash/isEmpty';
import { useDispatch } from 'react-redux';
import { UploadOutlined } from '@ant-design/icons';
import { ReactSVG } from 'react-svg';
import { useSelector } from 'react-redux';

import { doUploadOrdersFromFile } from '../../../modules/orders/store/thunk';
import './ImportOrders.scss';
// import { selectAllLocations } from '../../../modules/locations/stores/slice';

// const MAP_CSV_DATA = {
//   'Order Type': 'orderType',
//   'Order Ref': 'orderRef',
//   'Delivery Date': 'deliveryDate',
//   Load: 'load',
//   Platform: 'createdBy',
//   Name: 'name',
//   Description: 'description',
//   Expected: 'expected',
//   'Size Length': 'sizeLength',
//   'Size Width': 'sizeWidth',
//   'Size Height': 'sizeHeight',
//   Weight: 'weight',
//   'Location ID': 'locationId',
//   // 'Pickup Phone': 'pickupPhone',
//   'Pickup Note': 'pickupNote',
//   'Pickup Duration': 'pickupDuration',
//   'Shopper Name': 'deliveryName',
//   'Shopper Email': 'deliveryEmail',

//   'Shopper Street': 'street',
//   'Shopper House Number': 'houseNumber',
//   'Shopper Suffix': 'suffix',
//   'Shopper Postal Code': 'postalCode',
//   'Shopper City': 'city',
//   'Shopper Country Code': 'countryCode',
//   'Shopper Address Latitude': 'deliveryAddressLat',
//   'Shopper Address Longitude': 'deliveryAddressLng',
//   'Shopper Phone': 'deliveryPhone',
//   'Delivery Time Start': 'deliveryTimeStart',
//   'Delivery Time End': 'deliveryTimeEnd',
//   'Delivery Note': 'deliveryNote',
//   'Delivery Duration': 'deliveryDuration',
//   Types: 'types',
//   Region: 'region',
//   'Is Return': 'isReturn',
// };

const ImportOrders = ({ onCancel }) => {
  const [fileRecords, setFileRecords] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [rawFile, setRawFile] = useState(null);
  const [feedback, setFeedback] = useState(null);
  const [failed, setFailed] = useState(null);
  const dispatch = useDispatch();
  const isFetching = useSelector((state) => state.order.isFetching);

  const handleBeforeUpload = (file) => {
    setRawFile(file);
    const fileReader = new FileReader();
    fileReader.onload = (event) => {
      try {
        const { result } = event.target;
        let data = [];

        if (file.name.endsWith('.xlsx') || file.name.endsWith('.xls')) {
          const workbook = XLSX.read(result, { type: 'binary' });
          for (const sheet in workbook.Sheets) {
            data = data.concat(XLSX.utils.sheet_to_json(workbook.Sheets[sheet]));
          }
        } else if (file.name.endsWith('.csv')) {
          Papa.parse(result, {
            header: true,
            skipEmptyLines: true,
            dynamicTyping: true,
            complete: (results) => {
              data = results.data;
            },
          });
        } else {
          setFeedback('File type is not supported.');
          return;
        }
        // Check for required and optional fields in the imported data
        if (data.length > 0) {
          const headers = Object.keys(data[0]);
          const requiredFields = [
            'orderRef',
            'locationId',
            'deliveryStreet',
            'deliveryNumber',
            'deliveryPostalCode',
            'deliveryCity',
            'deliveryCountry',
          ];

          const optionalFields = [
            'name',
            'description',
            'length',
            'width',
            'height',
            'weight',
            'pickupNote',
            'deliveryName',
            'deliveryEmail',
            'deliverySuffix',
            'deliveryNote',
            'deliveryDate',
            'deliveryPhone',
          ];

          const allValidFields = [...requiredFields, ...optionalFields];

          // Check for missing required fields
          const missingRequiredFields = requiredFields.filter((field) => !headers.includes(field));

          // Check for unrecognized fields
          const unrecognizedFields = headers.filter((field) => !allValidFields.includes(field));

          if (missingRequiredFields.length > 0) {
            setFeedback(`Missing required fields: ${missingRequiredFields.join(', ')}`);
            return;
          }

          if (unrecognizedFields.length > 0) {
            setFeedback(
              `Unrecognized fields found: ${unrecognizedFields.join(', ')}. Only required and optional fields are allowed.`,
            );
            return;
          }
        } else {
          setFeedback('The file appears to be empty.');
          return;
        }

        setFileRecords(data);
      } catch (e) {
        setFeedback(`Something went wrong: ${e.message}`);
      }
    };

    fileReader.readAsBinaryString(file);
  };

  const handleOnRemove = () => {
    setFileList([]);
    setFileRecords([]);
    setRawFile(null);
    setFeedback(null);
  };

  const handleCancel = () => {
    onCancel();
    handleOnRemove();
  };

  const handleImportOrders = async () => {
    // const items = fileRecords.map((record) => {
    //   const obj = {};
    //   Object.keys(MAP_CSV_DATA)?.forEach((key) => {
    //     const fieldName = MAP_CSV_DATA[key];
    //     const value = record[key];
    //     if (key === 'Location ID') {
    //       const location = _find(locations, { locationId: value });
    //       obj[fieldName] = location?.locationId;
    //       obj['pickupName'] = location?.name;
    //       obj['pickupAddress'] = location?.address;
    //       obj['pickupAddressLat'] = location?.addressLat;
    //       obj['pickupAddressLng'] = location?.addressLng;
    //       obj['pickupEmail'] = location?.email;
    //     } else if (key === 'Tags') {
    //       obj[fieldName] = value?.split(',')?.map((tagName) => _find(tags, { name: tagName?.toLowerCase() })?.id);
    //     } else if (key === 'Types') {
    //       obj[fieldName] = value?.split(',');
    //     } else if (
    //       [
    //         'Shopper Name',
    //         'Shopper Email',
    //         'Shopper Address Latitude',
    //         'Shopper Address Longitude',
    //         'Shopper Phone',
    //       ].includes(key)
    //     ) {
    //       obj[fieldName] = value ? String(value) : value;
    //     } else if (
    //       [
    //         'Shopper Street',
    //         'Shopper House Number',
    //         'Shopper Suffix',
    //         'Shopper Postal Code',
    //         'Shopper City',
    //         'Shopper Country Code',
    //       ].includes(key)
    //     ) {
    //       obj.deliveryAddress = {
    //         ...obj.deliveryAddress,
    //         [fieldName]: value ? String(value) : value,
    //       };
    //     } else if (key === 'Expected' && value === 'true') {
    //       obj.status = ORDER_STATUSES.EXPECTED;
    //     } else if (key === 'Is Return') {
    //       if (value === 'true') {
    //         obj.isReturn = true;
    //       }
    //     } else {
    //       obj[fieldName] = value;
    //     }
    //   }, []);
    //   // some cleanup for expected orders
    //   if (obj.status === ORDER_STATUSES.EXPECTED) {
    //     obj.deliveryTimeStart = null;
    //     obj.deliveryTimeEnd = null;
    //   }
    //   delete obj.expected;
    //   // turn around pick up delivery if isReturn
    //   if (obj.isReturn) {
    //     obj.pickupName = obj.deliveryName;
    //     obj.pickupAddress = obj.deliveryAddress;
    //     obj.pickupAddressLat = obj.deliveryAddressLat;
    //     obj.pickupAddressLng = obj.deliveryAddressLng;
    //     obj.pickupPhone = record['Shopper Phone'];
    //     obj.pickupEmail = obj.deliveryEmail;
    //     delete obj.deliveryEmail;
    //     delete obj.deliveryAddress;
    //     delete obj.deliveryAddressLat;
    //     delete obj.deliveryAddressLng;
    //   }
    //   return obj;
    // });

    try {
      // const res = await dispatch(doImportOrders({ items }));
      const res = await dispatch(doUploadOrdersFromFile({ file: rawFile }));

      if (res.payload?.failed?.length > 0) {
        setFailed(res.payload.failed);
        // setFileList([]);
        handleOnRemove();
      } else if (_isEmpty(res?.error)) {
        onCancel();
        handleOnRemove();
      }
    } catch (err) {
      setFeedback(`Something went wrong: ${err.message}`);
    }
  };

  const headerKeys = Object.keys(Object.assign({}, ...fileRecords));

  const downloadCsv = () => {
    const header = ['orderRef', 'error', 'data'].join(';');
    const csvData = [header]
      .concat(failed.map((f) => [f.order.orderRef, f.error, JSON.stringify(f.order)].join(';')))
      .join('\n');
    const blob = new Blob([csvData], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.setAttribute('hidden', '');
    a.setAttribute('href', url);
    a.setAttribute('download', 'errors.csv');
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };
  return (
    <div className="ImportOrders">
      <Upload.Dragger
        multiple={false}
        maxCount={1}
        accept=".xlsx, .xls, .csv"
        showUploadList={{
          showPreviewIcon: false,
          showDownloadIcon: false,
          showRemoveIcon: true,
        }}
        beforeUpload={handleBeforeUpload}
        listType="picture-card"
        fileList={fileList}
        onRemove={handleOnRemove}
        onChange={(info) => setFileList(info?.fileList)}
        customRequest={async ({ onSuccess, onError }) => {
          try {
            onSuccess('ok');
          } catch (e) {
            console.log(e);
            onError();
          }
        }}
      >
        <p className="upload-text">Drag and drop to upload or</p>
        <p className="upload-drag-icon">
          Browse
          <UploadOutlined />
        </p>
      </Upload.Dragger>
      <p>Supports files in .xlsx, .xls and .csv format</p>
      <p>
        Download Sample File:{' '}
        <a target="_blank" href="/import-orders/sample.xlsx" rel="noopener noreferrer">
          sample.xlsx
        </a>
      </p>
      <table className="order-table">
        <thead>
          <tr>
            {headerKeys.map((key) => (
              <th key={key} className="header-table">
                {key}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {fileRecords.map((item, idx) => (
            <tr key={`record-${idx}`}>
              {headerKeys.map((key) => (
                <td key={key}>{item[key]}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      {feedback && (
        <div>
          <p style={{ color: 'red' }}>{feedback}</p>
        </div>
      )}
      {failed && (
        <div>
          <p style={{ color: 'red' }}>
            Not all orders were uploaded: {failed.length} failed. See{' '}
            <span style={{ color: 'blue', textDecoration: 'underline', cursor: 'pointer' }} onClick={downloadCsv}>
              report
            </span>{' '}
            for details
          </p>
        </div>
      )}
      <br />
      <div className="bottom-buttons">
        <Button onClick={handleCancel}>Cancel</Button>
        <Button
          type="primary"
          onClick={handleImportOrders}
          loading={isFetching}
          disabled={isFetching || !fileRecords?.length}
        >
          Confirm
          <ReactSVG className="icon" src="/icons/done.svg" />
        </Button>
      </div>
    </div>
  );
};

export default memo(ImportOrders);
